<div class="wrap">
  <div class="header">{{ header }}</div>
  <div class="close-btn" (click)="closeClicked.next()">
    <app-svg-icon [name]="'close'"></app-svg-icon>
  </div>
</div>
